/**
 * @file help
 * @author wangzhuang
 */

import {GET_HELPAPI_INDEX} from '../actions/ActionTypes';

export function helpapiIndex(state = {}, action) {
    switch (action.type) {
        case GET_HELPAPI_INDEX:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/help.js